module.exports = __webpack_public_path__ + "img/1-sm.cdf4cdd0.jpg";